import React, { createContext, useContext } from "react";

import {
	CloseButton,
	LoadingOverlay,
	LoadingSpinner,
	VerificationContainer,
	VerificationModal,
} from "./elements";
import useController from "./useController";

const VerificationContext = createContext({});

export const useVerification = () => useContext(VerificationContext);

const VerificationPopup = ({ children }) => {
	const {
		state: { open, isLoading, verificationRequest, isSumSubTokenLoading },
		handlers: { withVerification, handleVerificationClose, handleVerificationIframeError },
	} = useController();

	return (
		<VerificationContext.Provider value={{ withVerification }}>
			{children}
			{open && (
				<VerificationContainer>
					<VerificationModal>
						<CloseButton onClick={handleVerificationClose}>×</CloseButton>
						{isLoading || isSumSubTokenLoading ? (
							<LoadingOverlay>
								<LoadingSpinner />
							</LoadingOverlay>
						) : (
							<iframe
								src={verificationRequest?.weblink}
								onError={handleVerificationIframeError}
								style={{
									border: 0,
									width: "100%",
									height: "100%",
									display: "block",
								}}
							/>
						)}
					</VerificationModal>
				</VerificationContainer>
			)}
		</VerificationContext.Provider>
	);
};

export default VerificationPopup;
